import useNetwork from '@/hooks/useNetwork';
import { useConnect } from '@lore/query-connect';
import { getEducatorFilter } from './filterConfig';

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 0,
    returnCsvQuery = false
  } = props;

  const network = useNetwork();

  const query = {
    where: {
      ...getEducatorFilter(search, network)
    },
    pagination: {
      page: search.page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc'
    }
  };

  const result = useConnect('user.find', query, {
    enabled: !returnCsvQuery,
    keepPreviousData: true
  });

  if (returnCsvQuery) {
    return query;
  }

  return result;
}
